module.exports = __webpack_public_path__ + "static/account-79afdcd4e903d2eb2f121ce56c5bb5b0.png";